export default {
  categorytype: 'Category type',
  categorytypes: 'Category types',
  verbose_categorytype: 'a category type',

  select_categorytypes: 'Select a category type',
};
